import { BgColorsOutlined } from '@ant-design/icons';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { StyledButton } from '../ImageViewer.style';
import type { ThermalViewMode } from '../useThermalImage';

type ThermalViewProps = {
  onChange: (mode: ThermalViewMode) => void;
  value: ThermalViewMode;
};

export const ThermalView = ({ onChange, value }: ThermalViewProps) => {
  const { t } = useTranslation();
  const isRaw = value === 'raw';
  const handleClick = useCallback(() => onChange(isRaw ? 'colorized' : 'raw'), [isRaw, onChange]);

  return (
    <StyledButton
      data-testid="image-controls-thermal-view"
      title={
        isRaw
          ? t('images.switchToColorized', 'Viewing raw radiometry. Switch to colorized image')
          : t('images.switchToRaw', 'Viewing colorized image. Switch to raw radiometry')
      }
      type={isRaw ? 'primary' : 'default'}
      onClick={handleClick}
      icon={<BgColorsOutlined />}
    />
  );
};
